export default {
  methods: {
    numValidate() {
      if (this.num) {
        const pattern = /^[.\d]+$/

        if (this.inputValue && !pattern.test(String(this.inputValue).trim())) {
          this.message =
            '​Используйте только числа и точку для разделения десятичной части!'
          this.status = 'error'
          return false
        } else {
          this.message = ''
          this.status = 'done'
          this.isEmptyValue = false
          return true
        }
      } else {
        this.message = ''
        this.status = 'done'
        this.isEmptyValue = true
        return true
      }
    },
  },
}
